import { render, staticRenderFns } from "./FormSubscriptor.vue?vue&type=template&id=acbc80d2"
import script from "./FormSubscriptor.vue?vue&type=script&lang=js"
export * from "./FormSubscriptor.vue?vue&type=script&lang=js"
import style0 from "./FormSubscriptor.vue?vue&type=style&index=0&id=acbc80d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports